<template>
  <div
    class="modal fade"
    id="add-privileges-group"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body">
          <LoadingElement v-if="loading" />

          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            id="add-privileges-group-close"
            aria-label="Close"
          ></button>

          <div class="bs-stepper wizard-vertical-icons-example mt-2">
            <div class="bs-stepper-header">
              <div
                @click.prevent="goStep(1)"
                class="step"
                role="button"
                data-target="#general-info"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle">
                    <i class="ti ti-user"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("admins.general_info")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("admins.add_general_info")
                    }}</span>
                  </span>
                </button>
              </div>
              <div class="line"></div>
              <div
                @click.prevent="goStep(2)"
                class="step"
                role="button"
                data-target="#other-info"
              >
                <button type="button" class="step-trigger">
                  <span class="bs-stepper-circle"
                    ><i class="ti ti-adjustments-cog"></i>
                  </span>
                  <span class="bs-stepper-label">
                    <span class="bs-stepper-title">{{
                      $t("admins.privileges")
                    }}</span>
                    <span class="bs-stepper-subtitle">{{
                      $t("admins.choose_privileges")
                    }}</span>
                  </span>
                </button>
              </div>
            </div>
            <div class="bs-stepper-content">
              <form onSubmit="return false">
                <!-- general Info -->
                <div id="general-info" class="content">
                  <div class="row g-6">
                    <div class="col-md-6">
                      <label class="form-label" for="">{{
                        $t("groups.name")
                      }}</label>
                      <input
                        type="text"
                        v-model="group.name"
                        @input="validate"
                        class="form-control"
                        aria-describedby="basic-addon34"
                        :placeholder="$t('groups.name')"
                        :class="{ 'is-invalid': errors.name }"
                      />
                      <div v-if="errors.name" class="invalid-feedback">
                        {{ errors.name }}
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label class="form-label" for="">{{
                        $t("groups.type")
                      }}</label>
                      <select
                        v-model="group.type"
                        @change="fetchPrivileges(group.type)"
                        class="form-select"
                        aria-label="Default select example"
                      >
                        <option value="admins">{{
                          $t("groups.admins")
                        }}</option>
                        <option value="resellers">{{
                          $t("groups.resellers")
                        }}</option>
                      </select>
                    </div>
                    <div class="col-12">
                      <label class="form-label" for="">{{
                        $t("groups.description")
                      }}</label>
                      <textarea
                        v-model="group.description"
                        class="form-control"
                        rows="5"
                        :placeholder="$t('groups.description')"
                      />
                    </div>

                    <div class="col-12 d-flex justify-content-between">
                      <button class="btn btn-label-secondary btn-prev" disabled>
                        <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                        <span class="align-middle d-sm-inline-block d-none">{{
                          $t("control.previous")
                        }}</span>
                      </button>
                      <button
                        @click.prevent="nextStep"
                        class="btn btn-primary btn-next"
                      >
                        <span
                          class="align-middle d-sm-inline-block d-none me-sm-2"
                          >{{ $t("control.next") }}</span
                        >
                        <i class="ti ti-arrow-right ti-xs"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Social Links -->
                <div id="other-info" class="content">
                  <div class="mb-6">
                    <h5 class="card-header">
                      <div class="d-inline-block">
                        <input
                          type="checkbox"
                          @input="selectAllAll()"
                          v-model="privileges.selected"
                          class="form-check-input"
                        />
                      </div>
                      <label for=""
                        ><h4 class="mx-1">
                          {{ $t("groups.privileges") }}
                        </h4></label
                      >
                    </h5>
                    <hr class="m-0" />
                  </div>
                  <div
                    v-for="(privilege_group, index) in privileges"
                    :key="index"
                  >
                    <div class="mb-6">
                      <h5 class="card-header m-0">
                        <div class="d-inline-block">
                          <input
                            type="checkbox"
                            @input="selectAllPrivileges(privilege_group)"
                            v-model="privilege_group.selected"
                            class="form-check-input"
                          />
                        </div>
                        <label for=""
                          ><h4 class="mx-1 my-4">
                            {{ privilege_group.label }}
                          </h4></label
                        >
                      </h5>
                      <hr class="m-0" />
                      <div class="row gap-y-5 gap-x-0 mt-1">
                        <div
                          class="col-12 col-md-4"
                          v-for="(privilege, index) in privilege_group.children"
                          :key="index"
                        >
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :name="privilege.id"
                            :id="privilege.id"
                            v-model="privilege.selected"
                          />
                          <label :for="privilege.id">{{
                            privilege.label
                          }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-between mt-7">
                    <button
                      @click.prevent="previousStep"
                      class="btn btn-label-secondary btn-prev"
                    >
                      <i class="ti ti-arrow-left ti-xs me-sm-2"></i>
                      <span class="align-middle d-sm-inline-block d-none">{{
                        $t("control.previous")
                      }}</span>
                    </button>
                    <button
                      class="btn btn-success"
                      @click.prevent="store"
                      :disabled="!validated"
                    >
                      {{ this.group.id ? $t("groups.save") : $t("groups.add") }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters, mapState } from "vuex";
import { hasPrivilege } from "../../global_constants";
export default {
  name: "AddGroup",
  computed: {
    ...mapGetters(["user", "settings"]),
  },
  created() {},
  data() {
    return {
      error: "",
      message: "",
      error_message: "",
      currentImageUrl: null,
      currentLogoUrl: null,
      currentSignatureUrl: null,
      loading: false,
      group: {
        name: "",
        description: "",
        privileges: [],
        type: "admins",
      },
      privileges: [],
      options: [
        {
          id: 0,
          label: "All",
          isDefaultExpanded: true,
          children: null,
        },
      ],
      errors: {
        name: null,
        privileges: null,
      },
      validated: false,
      stepper: null,
      server_url: localStorage.getItem("server"),
    };
  },
  async created() {
    this.loading = true;
    if (this.$route.query.group_id) {
      await this.fetchGroup();
      this.validate();
    } else {
      await this.fetchPrivileges("admins");
    }
  },
  mounted() {
    this.stepper = new Stepper(document.querySelector(".bs-stepper"), {
      linear: true,
      animation: false,
      selectors: {
        steps: ".step",
        trigger: ".step-trigger",
        stepper: ".bs-stepper",
      },
    });
  },
  methods: {
    nextStep() {
      this.stepper.next();
    },
    previousStep() {
      this.stepper.previous();
    },
    goStep(num) {
      this.stepper.to(num);
    },
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    async fetchGroup() {
      this.loading = true;
      const response = await axios.get(`groups/${this.$route.query.group_id}`);
      if (response.status == 200) {
        this.group = response.data.data;
        await this.fetchPrivileges(this.group.type);
        this.privileges.forEach((privilege_group) => {
          privilege_group.children.forEach((privilege) => {
            if (this.group.privileges.find((str) => str === privilege.id))
              privilege.selected = true;
          });
        });
      }
      this.loading = false;
    },
    async fetchPrivileges(type) {
      this.loading = true;
      const response = await axios.get(`${type}/privileges`);
      this.privileges = response.data;
      this.loading = false;
    },
    checkAll(data, model) {
      if (!model.checkAll) {
        data.forEach((element) => {
          model.push(element);
        });
      } else {
        model.splice(0, model.length);
      }
    },
    selectAllAll() {
      if (this.privileges.selected) {
        this.privileges.forEach((group) => {
          group.selected = false;
          group.children.forEach((privilege, index) => {
            group.children[index].selected = false;
          });
        });
      } else {
        this.privileges.forEach((group) => {
          group.selected = true;
          group.children.forEach((privilege, index) => {
            group.children[index].selected = true;
          });
        });
      }
    },
    selectAllPrivileges(group) {
      if (group.selected) {
        group.children.forEach((privilege, index) => {
          group.children[index].selected = false;
        });
      } else {
        group.children.forEach((privilege, index) => {
          group.children[index].selected = true;
        });
      }
    },
    async store() {
      this.loading = true;
      this.group.privileges = [];
      this.privileges.forEach((privilege_group) => {
        privilege_group.children.forEach((privilege) => {
          if (privilege.selected) this.group.privileges.push(privilege.id);
        });
      });

      if (this.group.id) {
        var data = new FormData();
        data.append("name", this.group.name);
        data.append("description", this.group.description);
        data.append("type", this.group.type);
        for (let i = 0; i < this.group.privileges.length; i++) {
          data.append("privileges[]", this.group.privileges[i]);
        }
        var response = await axios.post(`/groups/${this.group.id}`, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      } else {
        var data = new FormData();
        data.append("name", this.group.name);
        data.append("description", this.group.description);
        data.append("type", this.group.type);
        for (let i = 0; i < this.group.privileges.length; i++) {
          data.append("privileges[]", this.group.privileges[i]);
        }
        var response = await axios.post("/groups", data, {
          headers: { "Content-Type": "multipart/form-data" },
        });
      }

      if (response.status == 200) {
        this.loading = false;
        document.getElementById("add-privileges-group-close").click();
        if (this.group.id)
          this.$notify({
            text: this.$t("messages.privileges_group_updated_successfully"),
            type: "success",
          });
        else
          this.$notify({
            text: this.$t("messages.privileges_group_added_successfully"),
            type: "success",
          });
        this.$emit("updated");
      }
    },
    validate() {
      this.validated = true;
      this.errors.name = null;
      this.errors.privileges = null;
      if (this.group.name.length < 2) {
        this.validated = false;
        this.errors.name = this.$t("groups.name_required");
      }
    },
    selectAll() {
      this.group.privileges = [];
      this.privileges.forEach((element) => {
        element.children.forEach((privilege) => {
          this.group.privileges.push(privilege.id);
        });
      });
    },
  },
};
</script>
